module.exports = {"channel":"VPP_Horses_Flats"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/configurations/subCategory.json
// module id = 628
// module chunks = 0